import { Provider } from "@redotech/redo-model/order";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * @deprecated Use `getMarketingEcommerceProviders` for marketing-specific providers.
 * // TODO (@stewartthompson) Remove this endpoint in January 2026.
 */
export const getTeamEcommerceProviders = {
  name: "getTeamEcommerceProviders" as const,
  input: z.object({}),
  output: z.object({
    default: createEnum(Provider),
    available: z.array(createEnum(Provider)),
  }),
};
